import { FC, useCallback } from 'react';

import SignersContainer from 'components/SendDocuments/SignersContainer';
import ButtonAddOutline from 'components/Sidebar/ButtonAddOutline';
import SignerFlowComponent from 'components/SignNow/SignerFlow';
import { EMPTY_SIGNER } from 'constants/sendDocuments';
import { SIGNER_FLOW_CONFIG, SignerFlow } from 'constants/signNow';
import useSignerFlowInSendFlow from 'hooks/SendFlow/useSignerFlowInSendFlow';
import { ISelectSigners } from 'types/SendDocuments';
import { isManagerAssignment } from 'utils/assignmentsHelpers';

const SelectDocumentSigners: FC<ISelectSigners> = ({
  signersArray,
  setSignersArray,
}) => {
  const {
    onlyCollection,
    signingOrderFlow,
    changeSignerFlowHandler,
    addBulkSendFlow,
  } = useSignerFlowInSendFlow();

  const handlerAddButton = useCallback(() => {
    setSignersArray([...signersArray, { ...EMPTY_SIGNER, position: signersArray.length }]);
  }, [setSignersArray, signersArray]);

  return (
    <div className="text-start">
      <div className="mt-3 select-signers-title">Please select and order signers</div>
      {
        !onlyCollection && (
          <div className="d-flex justify-content-between align-items-end flex-wrap gap-4">
            <SignerFlowComponent
              addBulkSendFlow={addBulkSendFlow}
              config={SIGNER_FLOW_CONFIG}
              onChange={changeSignerFlowHandler}
              currentSignerFlow={signingOrderFlow ?? SignerFlow.OrderedSigning}
              disableJustMeFlow={!signersArray.some((signer) => isManagerAssignment(signer.type))}
            />
          </div>
        )
      }
      <SignersContainer
        signersArray={signersArray}
        setSignersArray={setSignersArray}
        isOrderVisible={signingOrderFlow === SignerFlow.OrderedSigning}
        canDeleteCard={signingOrderFlow !== SignerFlow.JustMe}
        isOnlyCollection={onlyCollection}
      />
      {/* TODO!!!  */}
      {/* {
        signingOrderFlow !== SignerFlow.JustMe && !onlyCollection && (
          <ButtonAddOutline onClick={handlerAddButton} title="Add signers" />
        )
      } */}
      {
        addBulkSendFlow && signingOrderFlow === SignerFlow.BulkSend && (
          <ButtonAddOutline onClick={handlerAddButton} title="Add signers" />
        )
      }
    </div>
  );
};

export default SelectDocumentSigners;